<template>
  <button
    disabled
    :style="{
      backgroundColor: bgcolor,
      height: height + 'px',
      width: width,
      margin,
      padding
    }"
  >
    <div class="spinner">
      <div :style="{ backgroundColor: color }" class="bounce1"></div>
      <div :style="{ backgroundColor: color }" class="bounce2"></div>
      <div :style="{ backgroundColor: color }" class="bounce3"></div>
    </div>
  </button>
</template>

<script>
export default {
  name: "LoadingButton",
  props: {
    color: { default: "#ACACAC" },
    bgcolor: { default: "#DDDDDD" },
    height: { default: 30 },
    width: { default: "auto" },
    margin: { default: "0" },
    padding: { default: "0 2rem" }
  }
};
</script>

<style scoped>
.spinner {
  margin: auto;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

button {
  border: none;
  border-radius: 50px;
  min-width: 30px;
  outline: none;
}

button:focus,
button:active {
  outline: none;
}
</style>
